<template>
  <el-container id="debts-screen" style="justify-content: center">
    <el-col
      class="main-wrapper"
      :xs="24"
      :sm="23"
      :md="22"
      :lg="22"
      :xl="19"
    >
      <el-row class="banner">
        <el-col
          class="left-container"
          :xs="24"
          :sm="10"
          :md="10"
          :lg="10"
          :xl="12"
        >
          <div class="field-group">
            <div class="field">
              Nombre:
            </div>
            <div class="value">
              {{ user.nombrecompletopropietario }}
            </div>
          </div>
          <div class="field-group">
            <div class="field">
              Id consulta:
            </div>

            <div class="value">
              {{ user.id_consulta }}
            </div>
          </div>
          <div class="field-group">
            <div class="field">
              Direción:
            </div>
            <div class="value">
              {{ user.ubicacion }}
            </div>
          </div>
          <div class="field-group" v-if="user.cuentadepredial!=null && user.cuentadepredial.length > 1">
            <div class="field">
              Cuenta predial:
            </div>
            <div class="value">
              {{ user.cuentadepredial }}
            </div>
          </div>
          <div class="field-group">
            <div class="field">
              Padrón:
            </div>
            <div class="value">
              {{ user.pk }}
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="10"
          :lg="8"
          :xl="5"
          class="right-container"
        >
          <div class="logo-wrapper">
            <img
              src="./../assets/images/logo-tesoreria.png" alt="logo tesoreria"
              class="logo"
            >
          </div>
          <el-row class="actions-wrapper" :gutter="5">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
            >
              <a :href="$router.resolve({name:'busqueda-del-predio'}).href" class="el-button el-button--primary">Consultar otra cuenta</a>
            </el-col>
            <!--            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12"
            >
              <el-button
                type="primary"
                style="width:100%"
                @click="goToReceipt"
                :loading="receiptBtnLoading"
              >
                {{ !receiptBtnLoading ? 'Imprimir último recibo' : 'Cargando' }}
              </el-button>
            </el-col>-->
            <el-col :span="24">
              <el-button
                type="primary"
                style="width:100%"
                @click="goEstadoDeCuenta"
                :disabled="!tableData.length"
              >
                Imprimir Estado de cuenta
              </el-button>
              <!--<el-button
                type="primary"
                style="width:100%"
                @click="goEstadoDeCuentaNuevo"
                :disabled="!tableData.length"
              >
                Imprimir Estado de cuenta
              </el-button>-->
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="table-wrapper">
        <el-table
          id="main-table"
          :data="tableData"
          style="width: 100%"
          height="100%"
          border
        >
          <el-table-column
            fixed
            prop="check"
            width="40"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                :disabled="scope.row.disabled"
                @change="(val) => onCheck(scope, val)"
              />
              <!-- JEO :disabled="scope.row.disabled" -->
            </template>
          </el-table-column>
          <el-table-column
            prop="observaciones"
            label="Descripción"
            min-width="226"
          />
          <el-table-column
            prop="importe_base"
            label="Imp. Base"
            min-width="100"
            :formatter="(r, c, val) => $currencyFormater(val)"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="recargo"
            label="Recargo"
            min-width="100"
            :formatter="surcharges"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="descuento_total"
            label="Desc."
            min-width="100"
            align="right"
            header-align="left"
            :formatter="discount"
          />
          <el-table-column
            prop="descuentoEspecial"
            label="Desc. Esp"
            min-width="88"
            :formatter="specialDiscount"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="actualizacion"
            label="Act."
            min-width="100"
            :formatter="(r, c, val) => $currencyFormater(val)"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="multa"
            label="Multa"
            min-width="72"
            :formatter="(r, c, val) => $currencyFormater(val)"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="descuento_multa"
            label="Dto. Multa"
            min-width="100"
            :formatter="finesDiscount"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="gasto"
            label="Gasto"
            min-width="72"
            :formatter="(r, c, val) => $currencyFormater(val)"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="adeudo"
            label="Adeudo"
            min-width="100"
            :formatter="debts"
            align="right"
            header-align="left"
          />
        </el-table>
        <table class="table-summary">
          <tr class="border">
            <th>Redondeo</th>
            <td align="center">
              {{ $currencyFormater(totalExtra) }}
            </td>
          </tr>
          <tr>
            <th>Total</th>
            <td align="center">
              {{ $currencyFormater(totalRounded) }}
            </td>
          </tr>
        </table>
        <el-row style="margin-top:10px;">
          <el-col
            :xs="24"
            :sm="24"
            :md="20"
            :lg="20"
            :xl="20"
          >
            <!-- <p style="margin-top:0px">
              Estimado contribuyente, si realiza su pago en línea se verá reflejado
              dentro de un lapso de 5 a 7 días hábiles por lo que le agradecemos llegado
              ese plazo, consulte de nuevo esta página para corroborar su pago aplicado.
            </p> -->
            <div>
              <strong>Conceptos</strong>
            </div>
            <div>
              <b>Imp.Base. - </b><span>Impuesto base</span>
            </div>
            <div>
              <b>Desc. - </b><span>Descuento</span>
            </div>
            <div>
              <b>Desc. Esp- </b><span>Descuento Especial</span>
            </div>
            <div>
              <b>Act. - </b><span>Actualización</span>
            </div>
            <div>
              <b>Dto. Multa. - </b><span>Descuento en la multa</span>
            </div>
            <br>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="4"
            :lg="4"
            :xl="4"
          >
            <el-button
              type="primary"
              @click="redirect"
              style="width:100%"
              :disabled="!tableData.length"
            >
              Continuar
            </el-button>
          </el-col>
        </el-row>
        <p class="schedule">
          Dirección de Ingresos
          <br>
          Horarios de atención de las recaudadoras:
          <br>
          Lunes a Viernes de 9:00 am. a 3:00 pm.
        </p>
      </el-row>
    </el-col>
  </el-container>
</template>
<script>
import Moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      currentDate: new Moment(),
      receiptBtnLoading: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.predio.user,
      data: (state) => state.predio.data,
    }),
    /**
     * Filtra los datos provenientes del Web Service
     * para solo mostrar en la tabla la información de adeudos
     * de predio.
     * @readonly
     * @returns Array<Object>
     */
    tableData() {
      // Expresión regular para buscar la palabra 'impuesto' en mayúscula y minúscula
      // const regExp = new RegExp('impuesto', 'i');
      const regExp = /(impuesto|gastos|notificacion)/i;
      // console.log(this.data);
      /**
       * Filtra los datos del web service aplicando la expresión
       * regular en el campo de 'observaciones'
       */
      const output = this.data.filter((x) => regExp.test(x.observaciones));
      // console.log(output);
      // Objeto de fecha
      const currentDate = new Moment();
      // Obtenemos el año actual en valor numérico
      const currentYear = parseInt(currentDate.format('YYYY'), 10);
      // Obtenemos el mes actual en valor numérico
      const currentMonth = parseInt(currentDate.format('MM'), 10);
      // Obtenemos el día actual en valor numérico
      const currentDay = parseInt(currentDate.format('DD'), 10);

      /**
       * Busca la información de adeudos de predio que ya han vendido
       * relativo a la fecha actual y modifica cada elemento en la
       * colección de ser necesario.
       */
      const arrayFields = output.map((x) => {
        // Buscamos el año con una expresión regular en el campo 'observaciones'.
        let yearMatch = /predial ([0-9]{0,4})|predial|gastos|notificacion/i.exec(x.observaciones)[1];
        // let yearMatch2003 = /predial (2003)|predial /i.exec(x.observaciones)[1];
        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        yearMatch = typeof yearMatch === 'string' ? parseInt(yearMatch, 10) : null;

        // Buscamos el número del bimestre con una expresión regular en el campo 'observaciones'.

        let numMatch = /(((bim.|bimestre) ([0-9]{0,2}))|predial|gastos|notificacion)/i.exec(x.observaciones)[2];
        const bim = /(((bim.|bimestre) ([0-9]{0,2}))|predial|gastos|notificacion)/i.exec(x.observaciones)[2];

        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        numMatch = typeof numMatch === 'string' ? parseInt(numMatch, 10) : null;

        /**
         * Verifica si el año y bimestre ya vencieron.
         * De ser cierto, coloca la bandera 'disabled' en 'true',
         * para que los datos no pueden ser deseleccionados de la tabla.
         */
        const months = (numMatch * 2) - 1;
        let mes = 0;
        if (bim) {
          mes = (parseInt(bim.replace('BIM. ', ''), 10) * 2) - 1;
          // console.log('bim '+bim+'num match '+months+'  year '+yearMatch);
        } else {
          mes = 0;
          yearMatch = false;
        }
        const regExpGastoEjecucion = new RegExp('gastos', 'i');
        const disabled = regExpGastoEjecucion.test(x.observaciones)
        || (yearMatch && yearMatch < currentYear)
        //  || (yearMatch && yearMatch >= currentYear && currentMonth > months)
        // || (yearMatch && yearMatch === currentYear && currentMonth <= months)
        || (yearMatch && yearMatch === currentYear && mes <= currentMonth)
        || (!yearMatch)
        || (yearMatch && yearMatch >= currentYear && numMatch
        && (currentMonth === mes && currentDay <= 15));
        // console.log("año "+yearMatch+" mes "+currentMonth+" disabeld "+disabled);

        // Retorna el elemento o información de predio con las banderas preparadas.
        return {
          ...x,
          disabled,
          currentYear: yearMatch && yearMatch >= currentYear,
          checked: typeof x.checked === 'boolean' ? x.checked : true,
        };
      });
      return arrayFields;
    },
    allChecked() {
      return this.tableData.every((x) => x.checked);
    },
    /**
     * Calcula y retorna el total de adeudo del predio
     * en base a la información de adeudos.
     * @readonly
     * @returns {Number}
     */
    total() {
      // Obtener todos los elementos que esten marcados en la tabla (checked = true).
      const items = this.tableData.filter((x) => x.checked === true);
      // Variable de suma.
      let sum = 0;
      // Recorremos todos los registros marcados
      for (let i = 0; i < items.length; i++) {
        // Obtenemos el registro
        const element = items[i];
        let adeudo = 0;
        console.log(`elemento current year ${element.currentYear}`);
        if (element.currentYear) {
          if (this.allChecked && this.allExpiredChecked) {
            adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable;
            console.log(`adeudo en descuento base${element.descuentoBase} descuenboaplicable ${element.descuentoAplicable}`);
          } else if (this.allExpiredChecked) {
            /*
              adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable
              + element.descuentoAplicableCargo
              + element.descuentoRecargoAplicable
              + element.descuentoMultaAplicable;
              */
            // adeudo = element.adeudo - element.descuentoBase;
            adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable;

            /// const adeudo = parseFloat(importe_base) + parseFloat(recargo) + parseFloat(gasto) + parseFloat(multa)
            // + parseFloat(actualizacion);
          } else {
            adeudo = element.adeudo - element.descuentoBase;
            console.log(`adeudo en descuento base all checked ${element.descuentoBase} element adeudo ${element.adeudo}`);
          }
        } else if (this.allExpiredChecked) {
          adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable;
        } else {
          adeudo = element.adeudo - element.descuentoBase;
        }

        sum += adeudo * 1000;
        console.log(`adeudo en for ${adeudo} suma ${sum}`);
      }
      /**
       * Dividimos la suma entre 1000 para
       * obtener el resultado filal con 4 decimales
       */
      sum /= 1000;
      console.log(`adeudo en function total ${sum}`);
      // Retornamos el total de la suma
      return sum;
    },
    /**
     * Retorna el total de adeudo del predio redondeado.
     * @readonly
     * @returns {Number}
     */
    totalRounded() {
      console.log(`reondeo en funcion total ${this.total}`);
      console.log(`reondeo en funcion totalrounded ${Math.round(this.total)}`);
      return Math.round(this.total);
    },
    /**
     * Retorna los decimales omitidos del total redondeado.
     * @readonly
     * @returns {Number}
     */
    totalExtra() {
      console.log(`extra ${this.totalRounded - this.total}`);
      return this.totalRounded - this.total;
    },
    disabledCount() {
      return this.tableData.filter((x) => x.disabled).length;
    },
    checkedCount() {
      return this.tableData.filter((x) => x.checked).length;
    },
    allExpiredChecked() {
      // return this.disabledCount < this.checkedCount;
      return true;
    },
  },
  methods: {
    goEstadoDeCuenta() {
      // console.log('HOLA');
      const allChecked = !this.tableData.some((x) => x.checked === false);
      this.$store.dispatch('predio/SET_ALL_ITEM_CHECKED', allChecked);
      this.$router.push({ path: '/estado-de-cuenta', query: this.$route.query });
    },
    goEstadoDeCuentaNuevo() {
      const { cuentadepredial, curt } = this.user;
      let param = cuentadepredial || curt;
      if (cuentadepredial == 0) {
        param = curt;
      }
      console.log(param);
    },
    /**
     * Manejador del evento click en el botón 'continuar'.
     * Verifica que el usuario haya seleccionado al menos
     * una fila y redirecciona a la pantalla de detalle de pago.
     * De lo contrario, muestra una alerta.
     */
    redirect() {
      if (this.totalRounded > 0) {
        this.$store.dispatch('predio/SET_ALL_ITEM_CHECKED', this.allChecked);
        this.$router.push({ path: '/detalles-de-pago', query: this.$route.query });
      } else {
        const h = this.$createElement;
        this.$msgbox({
          type: 'warning',
          title: 'Aviso',
          message: h('p', null, [
            'No es posible realizar el proceso de pago en línea, favor de',
            ' seleccionar por lo menos un ',
            h('strong', null, 'IMPUESTO PREDIAL'),
            ' para realizar su pago',
          ]),
          showButtonCancel: false,
          center: true,
        });
      }
    },
    /**
     * Cambia el valor de estado de un campo 'checkbox' en la tabla.
     * @param {Object} scope Objeto fila
     * @param {Object} val valor actual del 'checkbox'
     */
    onCheck(scope, val) {
      this.$store.dispatch('predio/SET_DATA_ITEM_CHECKED', { idx: scope.$index, state: val });
      // console.log('val '+val);
      for (let i = 0; i < this.tableData.length; i++) {
        if (scope.$index > i) {
          this.$store.dispatch('predio/SET_DATA_ITEM_CHECKED', { idx: i, state: true });
        }
        if (scope.$index < i) {
          this.$store.dispatch('predio/SET_DATA_ITEM_CHECKED', { idx: i, state: false });
        }
      }
      const SHOW_TRACE = false;
      if (SHOW_TRACE) {
        setTimeout(() => {
          let acumTotal = 0;
          let acumTotalSums = 0;
          const rows = document.querySelectorAll('.el-table__row');
          rows.forEach((row) => {
            const checkbox = row.querySelector('.el-checkbox');
            const isChecked = checkbox.className.includes('is-checked');
            if (isChecked) {
              const lastTd = row.querySelector('td:last-of-type');
              const displayedTotal = parseFloat(
                parseFloat(lastTd.innerText.toString()
                  .replace('$', '').replace(',', '') || 0).toFixed(2),
              );
              let calculedTotalTds = 0;
              const restTd = row.querySelectorAll('td.is-right:not(:last-of-type)');
              const period = row.querySelector('td:nth-child(2) div').innerText;

              restTd.forEach((td, idx) => {
                const displayedTotals = parseFloat(
                  parseFloat(td.innerText.toString()
                    .replace('$', '').replace(',', '') || 0).toFixed(2),
                );
                if (displayedTotals) {
                  const sum = [
                    0,
                    1,
                    4,
                    5,
                    7,
                  ].includes(idx);
                  if (sum) {
                    calculedTotalTds += displayedTotals * 1000;
                  } else {
                    calculedTotalTds -= displayedTotals * 1000;
                  }
                }
              });
              acumTotalSums += calculedTotalTds;
              /* console.log({
                 displayedTotal: displayedTotal.toFixed(2),
                 calculedTotalTds: (calculedTotalTds / 1000).toFixed(2),
               }); */
              if (displayedTotal.toFixed(2) !== (calculedTotalTds / 1000).toFixed(2)) {
                /* console.log({
                  period,
                  displayedTotal: displayedTotal.toFixed(2),
                  calculedTotal: calculedTotalTds / 1000,
                }); */
              }
              if (displayedTotal) {
                acumTotal += displayedTotal * 1000;
              }
            }
          });
          acumTotal /= 1000;
          acumTotalSums /= 1000;
          // console.log({ acumTotalSums, acumTotal });
        }, 2);
      }
    },
    /**
     * Calcula y retorna en formato moneda el total de descuento especial de cada fila
     * @param {Object} scope Objeto fila
     * @returns {String}
     */
    specialDiscount(scope) {
      let output = 0;
      if (this.allChecked) {
        output = (scope.descuentoAplicableCargo || 0);
      }
      return this.$currencyFormater(output);
    },
    /**
     * Calcula y retorna en formato moneda el total de descuento de cada fila
     * @param {Object} scope Objeto fila
     * @returns {String}
     */
    discount(scope) {
      // let output = scope.descuentoBase || 0;
      // if (this.allChecked) {
      const output = (scope.descuentoRecargoAplicable || 0);
      // }
      return this.$currencyFormater(output);
    },
    /**
     * Calcula y retorna en formato moneda el total de adeudo de cada fila
     * @param {Object} scope Objeto fila
     * @returns {String}
     */
    debts(scope) {
      let output = scope.adeudo - scope.descuentoBase;
      // Buscamos el año con una expresión regular en el campo 'observaciones'.
      let yearMatch = /predial ([0-9]{0,4})|predial|gastos|notificacion/i.exec(scope.observaciones)[1];
      /**
       * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
       * convertir el valor de texto a valor numérico.
       */
      yearMatch = typeof yearMatch === 'string' ? parseInt(yearMatch, 10) : 0;
      // console.log('\nADEUDO ='+yearMatch+'='+scope.adeudo);
      const currentYear = this.currentDate.format('YYYY');
      if (yearMatch >= currentYear) {
        if (!scope.checked) {
          output = 0;
        } else if (this.allChecked && this.allExpiredChecked) {
          output = scope.adeudo - scope.descuentoBase;
        } else if (this.allExpiredChecked) {
          output = scope.adeudo - scope.descuentoBase;

          /*
          output = scope.adeudo - scope.descuentoBase
            // - scope.descuentoAplicable
            + scope.descuentoAplicableCargo + scope.descuentoRecargoAplicable
            + scope.descuentoMultaAplicable;
          */
        }
      } else if (this.allExpiredChecked) {
        output = scope.adeudo - scope.descuentoBase;
        // - scope.descuentoAplicable;
        // output = scope.adeudo - scope.descuentoBase ;
        // console.log('\descuento base allExpiredChecked ='+scope.descuentBase);
      }
      return this.$currencyFormater(output);
    },
    /**
     * Calcula y retorna en formato moneda el total de cargo de cada fila
     * @param {Object} scope Objeto fila
     * @returns {String}
     */
    surcharges(scope) {
      // let output = scope.recargo - scope.descuentoRecargo;
      const output = scope.recargo;
      /* if (scope.currentYear) {
        if (this.allChecked) {
          output -= scope.descuentoRecargoAplicable;
        }
      } else if (this.allExpiredChecked) {
        output -= scope.descuentoRecargoAplicable;
      } */
      return this.$currencyFormater(output);
    },
    fines(scope) {
      // let output = scope.multa - scope.descuentoMulta;
      const output = scope.multa;
      /* if (scope.currentYear) {
        if (this.allChecked) {
          output -= scope.descuentoMultaAplicable;
        }
      } else if (this.allExpiredChecked) {
        output -= scope.descuentoMultaAplicable;
      } */
      return this.$currencyFormater(output);
    },
    /**
     * Calcula y retorna en formato moneda el total de multas de cada fila
     * @param {Object} scope Objeto fila
     * @returns {String}
     */
    finesDiscount(scope) {
      const output = scope.descuentoMulta;
      /* if (this.allExpiredChecked) {
        output += (scope.descuentoMultaAplicable || 0);
      } */
      return this.$currencyFormater(output);
    },
    async goToReceipt() {
      try {
        this.receiptBtnLoading = true;
        const { cuentadepredial, curt } = this.user;
        let param = cuentadepredial || curt;
        // console.log('curt '+ curt);
        if (cuentadepredial == 0) {
          param = curt;
        }
        // console.log(param);
        const response = await this.axios.get(`/InformacionRecibo/${param}`);
        const { data } = response;
        if (data && !data.alerta) {
          this.$store.dispatch('receipt/SET_DATA', {
            reciboPDF: data.recibo,
            tipo: 'pago-predial',
          });
          setTimeout(() => {
            this.$router.push({ path: '/recibo-pdf' });
          });
        }
      } catch (error) {
        this.$ErrorNotify(error);
      } finally {
        this.receiptBtnLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#debts-screen {
  #main-table {
    table {
      th {
        background-color: #333333;
        color:#ffffff;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#debts-screen {
  .main-wrapper {
    .el-button {
      display: block;
      font-size: 10pt;
      font-weight: bold;
      text-decoration: none;
      margin: 5px 0px;
      margin-left: 0px !important;
      background-color: #764E84;
      &:hover {
        opacity: 0.9;
      }
    }
    .banner {
      display: flex;
      justify-content: space-between;
      .field-group {
        display: flex;
        flex-direction: row;
        margin: 5px 0px;
        line-height: 24px;
        .field {
          color: #956FA8;
          font-family: Arial;
          font-size: 13pt;
          font-weight: bold;
          width: 100%;
          min-width: 90px;
          max-width: 130px;
        }
        .value {
          display: flex;
          align-items: center;
          text-transform: uppercase;
          color: #4B5056;
          font-family: Arial;
          font-size: 10pt;
          font-weight: normal;
          height: inherit !important;
        }
      }
    }
    .right-container {
      .logo {
        position: relative;
        height: 120px;
        overflow: hidden;
        img {
          height: 100%;
          object-fit: contain;
        }
      }
      .actions-wrapper {
        margin: 10px 0px;
      }
    }
    .table-summary {
      height: auto;
      background-color: #9962A1;
      color: #ffffff;
      border-radius: 0px 0px 5px 5px;
      tr {
        &.border {
          th, td {
          border-bottom-width: 1px !important;
          }
        }
        th, td {
          border: solid #f0f0f0 !important;
          border-top-width: 0px !important;
          border-left-width: 0px !important;
          border-right-width: 0px !important;
          border-bottom-width: 0px !important;
        }
        th {
          padding: 5px 10px 5px 0px !important;
          border-right-width: 1px !important;
          padding: 5px 10px 5px 0px !important;
          min-width: 120px;
          width: 100%;
          text-align: right;
        }
        td {
          padding: 5px 10px 5px 5px !important;
          text-align: right;
          min-width: 60px;
        }
      }
    }
  }
  @media screen and (max-width: 767px){
    .banner {
      flex-direction: column-reverse;
    }
  }
  .schedule {
    color: rgba(0, 0, 0, 0.247);
    font-family: Arial;
    font-size: 10pt;
    font-weight: normal;
  }
}
</style>
